import React from 'react'

const AboutLightbox = () => {
  return (
    <div className='lightbox__paragraph'>
      <p>
        Dr. Sasha Chaddah has provided aesthetic treatments in London, ON, since 2003. She has partnered with <a href="https://redefinemd.com" target='_blank'>RedefineMD</a>, a boutique clinic in London, that offers patients a variety of non-invasive cosmetic procedures. Her approach to facial rejuvenation focuses on understanding your concerns and goals, and providing customized treatments that achieve a balanced, natural appearance in harmony with your unique facial proportions. 
        <br />
        <br />
        Dr. Chaddah is known for her integrity, honesty and professionalism. She is dedicated to developing long-lasting relationships of trust and respect with her patients (some have been with her for 15 years!). She views education, compassion and collaboration as key elements in helping patients achieve the positive aging outcomes they desire.        
        <br />
        <br />
        Dr. Chaddah regularly attends educational conferences and training programs and is a member of the following professional organizations:
      </p>
      <br />
      <br /> 
      <div>
        <ul>
            <li>&nbsp;&nbsp;  ‣ Canadian Association of Aesthetic Medicine</li>
            <li>&nbsp;&nbsp;  ‣ American Society for Laser Medicine and Surgery</li>
            <li>&nbsp;&nbsp;  ‣ Ontario Medical Association</li>
            <li>&nbsp;&nbsp;  ‣ Canadian Medical Association</li>
        </ul>
      </div>
      <br />
      <br />
      <p>
      Dr. Chaddah and the experienced team at <a href="https://redefinemd.com" target='_blank'>RedefineMD</a> are dedicated to delivering professional services which prioritize your comfort and safety. We look forward to helping you on your aesthetic journey.   
      </p>
      <br />
      <br />
      <br />
      <p><span style={{fontWeight:'bold'}}>Contact:</span> (519) 641-3000 or <a href="mailto:dr.chaddah@redefinemd.com">dr.chaddah@redefinemd.com</a>.</p>
    </div>
  )
}

export default AboutLightbox
